import type { PurchaserPortalKey } from "@src/domain/entities/purchaser";
import type { IPurchaserRepository } from "@src/domain/repositories/purchaser";
import type { UpdatePurchaserPortalKeyDTO } from "@src/domain/dto/purchasers";

export class UpdatePurchaserPortalKeyUseCase {
  private readonly purchaserRepository: IPurchaserRepository;

  constructor(purchaserRepository: IPurchaserRepository) {
    this.purchaserRepository = purchaserRepository;
  }

  execute(params: UpdatePurchaserPortalKeyDTO): Promise<PurchaserPortalKey> {
    return this.purchaserRepository.updatePurchaserPortalKey(params);
  }
}
